import AvaliacaoModeloItem from './AvaliacaoModeloItem';

export default class AvaliacaoModelo {
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.nome = '';
        this.descricao = '';
        this.cor = '#607D8B';
        this.frequenciaDias = 90;
        this.alertaVencimentoDias = 7;
        this.ativo = true;
        this.itens = [];

        if (!model)
            return;

        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId ? model.empresaId : 0;
        this.nome = model.nome;
        this.descricao = model.descricao;
        this.cor = model.cor ? model.cor : '#607D8B';
        this.frequenciaDias = model.frequenciaDias ? model.frequenciaDias : 90;
        this.alertaVencimentoDias = model.alertaVencimentoDias || model.alertaVencimentoDias === 0 ? model.alertaVencimentoDias : 7;
        this.ativo = model.ativo;
        this.itens = model.itens ? model.itens.map(x => new AvaliacaoModeloItem(x)) : [];

        if (model.createdAt)
            this.createdAt = model.createdAt;
        if (model.updatedAt)
            this.updatedAt = model.updatedAt;
    }
}
